const STORAGE_KEY = 'moozstate-wishlist-v1';

function readWishlist() {
  try {
    const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    return Array.isArray(saved) ? saved : [];
  } catch {
    return [];
  }
}

function writeWishlist(items) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

function updateToggle(toggle, saved) {
  const isSaved = saved.some((item) => item.handle === toggle.dataset.wishlistHandle);
  const title = toggle.dataset.wishlistTitle || 'product';

  toggle.classList.toggle('is-saved', isSaved);
  toggle.setAttribute('aria-pressed', String(isSaved));
  toggle.setAttribute('aria-label', `${isSaved ? 'Remove' : 'Add'} ${title} ${isSaved ? 'from' : 'to'} wishlist`);
}

function syncWishlistUI() {
  const saved = readWishlist();
  document.querySelectorAll('[data-wishlist-toggle]').forEach((toggle) => updateToggle(toggle, saved));
  document.querySelectorAll('[data-wishlist-page-link]').forEach((link) => {
    link.classList.toggle('is-saved', saved.length > 0);
  });
}

function createProductCard(item) {
  const article = document.createElement('article');
  article.className = 'wishlist-card';

  const imageLink = document.createElement('a');
  imageLink.href = item.url;
  imageLink.className = 'wishlist-card__image-link';

  if (item.image) {
    const image = document.createElement('img');
    image.src = item.image;
    image.alt = item.title;
    image.loading = 'lazy';
    image.width = 720;
    image.height = 900;
    imageLink.append(image);
  } else {
    const placeholder = document.createElement('div');
    placeholder.className = 'wishlist-card__placeholder';
    placeholder.textContent = item.title;
    imageLink.append(placeholder);
  }

  const details = document.createElement('div');
  details.className = 'wishlist-card__details';
  const title = document.createElement('a');
  title.href = item.url;
  title.textContent = item.title;
  const price = document.createElement('p');
  price.textContent = item.price || '';
  const remove = document.createElement('button');
  remove.type = 'button';
  remove.className = 'wishlist-card__remove';
  remove.dataset.wishlistRemove = item.handle;
  remove.textContent = 'Remove';

  details.append(title, price, remove);
  article.append(imageLink, details);
  return article;
}

function renderWishlistPage() {
  const page = document.querySelector('[data-wishlist-page]');
  if (!page) return;

  const grid = page.querySelector('[data-wishlist-product-grid]');
  const empty = page.querySelector('[data-wishlist-empty]');
  if (!grid || !empty) return;

  const items = readWishlist();

  grid.replaceChildren();
  items.forEach((item) => grid.append(createProductCard(item)));
  grid.hidden = items.length === 0;
  empty.hidden = items.length !== 0;
}

function toggleWishlist(button) {
  const product = {
    handle: button.dataset.wishlistHandle,
    title: button.dataset.wishlistTitle,
    url: button.dataset.wishlistUrl,
    price: button.dataset.wishlistPrice,
    image: button.dataset.wishlistImage,
  };

  if (!product.handle) return;

  const items = readWishlist();
  const existingIndex = items.findIndex((item) => item.handle === product.handle);
  if (existingIndex === -1) {
    items.push(product);
  } else {
    items.splice(existingIndex, 1);
  }

  writeWishlist(items);
  syncWishlistUI();
  renderWishlistPage();
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-wishlist-toggle]');
  if (toggle) {
    event.preventDefault();
    toggleWishlist(toggle);
    return;
  }

  const remove = event.target.closest('[data-wishlist-remove]');
  if (!remove) return;

  const items = readWishlist().filter((item) => item.handle !== remove.dataset.wishlistRemove);
  writeWishlist(items);
  syncWishlistUI();
  renderWishlistPage();
});

syncWishlistUI();
renderWishlistPage();
